import { createRouter, createWebHistory } from 'vue-router'

import adminUserRoute from './adminUserRoute.js'
import companyUserRoute from './companyUsersRoute.js'
import onboardingRoutes from '@/modules/onboarding/onboarding.routes.js'

import { syncChecklistContextFromRoute } from '@/helpers/checklistCompletion'
import dynamicUiText from '@/helpers/dynamicUiText'
import { useTerminologyStore } from '@/store/terminologyStore'
import {
    ensureValidSessionOrLogout,
    isLoginPath,
    isPublicPath,
    SESSION_EXPIRED_MESSAGE
} from '@/helpers/authSession'
import { createToaster } from '@meforma/vue-toaster'
import {
    isOnboardingIncomplete,
    getOnboardingEntryPath,
    ONBOARDING_CHOICE_PATH
} from '@/modules/onboarding/onboarding.guard.js'

const finalRoute = onboardingRoutes.concat(adminUserRoute.concat(companyUserRoute));

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: finalRoute,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active'
})

const sessionToaster = createToaster({ position: 'top-right', duration: 4000 });

function showSessionExpiredToast(message) {
    sessionToaster.error(message || SESSION_EXPIRED_MESSAGE);
}

/** While onboarding is incomplete, only allow choice / wizard / chat / login. */
const ONBOARDING_ALLOW_WHEN_INCOMPLETE = new Set([
    ONBOARDING_CHOICE_PATH,
    '/onboarding/wizard',
    '/onboarding/chat',
    '/onboardinglist',
    '/login'
]);

router.beforeEach((to, from, next) => {
    syncChecklistContextFromRoute(to);
    useTerminologyStore().prepareForRouteNavigation();
    var mainTitle = localStorage.getItem('companyName');
    if (mainTitle == null || mainTitle == '')
        mainTitle = 'Welcome';
    const rawTitleName = (to.name == 'undefinded' || typeof to.name === 'undefined' || to.name == null)
        ? 'login'
        : to.name
    const titleName = dynamicUiText.applyDynamicTerminology(String(rawTitleName))

    document.title = `${mainTitle} | ${titleName}`;
    window.scrollTo(0, 0);

    if (isPublicPath(to.path) || isPublicPath(to.fullPath) || isLoginPath(to.path)) {
        next();
        return;
    }

    if (!ensureValidSessionOrLogout({
        router,
        showToast: showSessionExpiredToast,
        skipRedirect: true
    })) {
        next({ path: '/login', replace: true });
        return;
    }

    if (isOnboardingIncomplete()) {
        const allowed =
            ONBOARDING_ALLOW_WHEN_INCOMPLETE.has(to.path) ||
            to.path.startsWith('/onboarding');
        if (!allowed) {
            next({ path: getOnboardingEntryPath(), replace: true });
            return;
        }
        // Non-Household must not land on the choice screen
        if (to.path === ONBOARDING_CHOICE_PATH) {
            const entry = getOnboardingEntryPath();
            if (entry !== ONBOARDING_CHOICE_PATH) {
                next({ path: entry, replace: true });
                return;
            }
        }
    }

    next();
})

export default router
